import React from 'react';
import { useRouter } from 'next/router';
import icons from '../../shared/assets/icons/redesign';

import './CommunityIntro.scss';

const { Info, Check } = icons;

export default function CommunityIntro(props) {
  const router = useRouter();

  return (
    <div className="communityIntro">
      <h2 className="communityIntro-title">
        Welkom bij onze community!
      </h2>

      <div className="communityIntro-message">
        <Info className="communityIntro-message-icon" />

        <p className="communityIntro-message-text">
          Op dit moment zijn de community groepen nog niet beschikbaar.
          We meten de interesse in deze nieuwe functionaliteit.
        </p>
      </div>

      <ul className="communityIntro-list">
        <li className="communityIntro-list-item">
          <div className="communityIntro-list-item-icon-wrap">
            <Check className="communityIntro-list-item-icon" />
          </div>

          Word lid van jouw geboortegroep
        </li>

        <li className="communityIntro-list-item">
          <div className="communityIntro-list-item-icon-wrap">
            <Check className="communityIntro-list-item-icon" />
          </div>

          Maak topics aan en reageer op elkaar
        </li>

        <li className="communityIntro-list-item">
          <div className="communityIntro-list-item-icon-wrap">
            <Check className="communityIntro-list-item-icon" />
          </div>

          Maak nieuwe vriend(inn)en
        </li>

        <li className="communityIntro-list-item">
          <div className="communityIntro-list-item-icon-wrap">
            <Check className="communityIntro-list-item-icon" />
          </div>

          Stel je vragen aan ervaringsdeskundigen
        </li>
      </ul>

      <button
        className="communityIntro-button"
        onClick={() => router.back()}
      >
        Terug
      </button>
    </div>
  );
}
